import Layout from '@modules/layout/components/layout';
import Permissions from '@security/permissions';

const SubpropertyPeoplePage = () =>
  import('@modules/subproperty-people/components/subproperty-people-page.vue');
const PlayerFormPage = () =>
  import('@modules/player/components/player-form-page.vue');
const InscriptionViewPage = () =>
  import('@modules/inscription/components/inscription-view-page.vue');

export default [
  {
    path: '',
    component: Layout,
    children: [
      {
        props: true,
        name: 'subpropertyPeople',
        path: '/subproperty/people/:tabName?/:subtabName?',
        component: SubpropertyPeoplePage,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.settingsEdit,
        },
      },
      {
        name: 'subpropertyPeoplePlayerNew',
        path: '/subproperty/people/player/new',
        component: PlayerFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.playerCreate,
        }
      },
      {
        name: 'subpropertyPeoplePlayerEdit',
        path: '/subproperty/people/player/:id/edit',
        component: PlayerFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.playerEdit,
        },
        props: true,
      },
      {
        name: 'subpropertyPeopleInscriptionDetail',
        path: '/subproperty/people/:subpropertyId/:tabName?/inscriptionView/:id',
        component: InscriptionViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.inscriptionRead,
        },
        props: true,
      },
    ],
  },
];
